import { useCallback, useEffect, useRef, useState } from "react";
import FolderIcon from '../../../assets/icons/folder-black.png';
import FileIcon from '../../../assets/icons/file.png';
import ZipIcon from '../../../assets/icons/zip-file-format.png';
import JsonIcon from '../../../assets/icons/json-icon.png';
import XmlIcon from '../../../assets/icons/xml-icon.png';
import TlogIcon from '../../../assets/icons/log.png';
import ListIcon from '../../../assets/icons/list.png'; 
import GridIcon from '../../../assets/icons/grid.png'; 
import { useDispatch, useSelector } from "react-redux";
import { Button } from "primereact/button";
import { ButtonGroup } from 'primereact/buttongroup';
import BreadcrumbView from "../../../components/BreadcrumbView";
import appActions from '../../../appActions';
import DownloadFile from "../../../components/DownloadFile";
import { Toast } from "primereact/toast";
import Loader from "../../../components/Loader";
import { ConfirmationDialog } from "../../../components/ConfirmationDialog";
import { isPermissionCodeValid } from "../../../utils/mics";
import { FileUpload } from "primereact/fileupload";
import axios from "axios";
import { showToast } from "../../../utils/toastActions";

const MediaDirectoryTree  = ({ pageId }) => {
    
    const readAccess = isPermissionCodeValid(`${pageId}-R`);
    const writeAccess = isPermissionCodeValid(`${pageId}-DL`);
    const deleteAccess = isPermissionCodeValid(`${pageId}-D`)
    const uploadAccess = isPermissionCodeValid(`${pageId}-UP`)
    
    const toast = useRef(null); 

    const dispatch = useDispatch();
    const mediaList = useSelector((state) => state.media.mediaList);
    const isDelete = useSelector((state) => state.media.isDelete);

    const [breadcrumb, setBreadcrumb] = useState([{ label: 'Home', path: '' },]);
    const [viewMode, setViewMode] = useState('grid');  // Default to grid view
    const [lastViewPath, setLastViewPath] = useState(); 
    const [deleteRecord, setDeleteRecord] = useState(null); 

    const loading = useSelector((state) => state.ui.loading); 

    useEffect(() => {
        dispatch(appActions.MEDIAMANAGEMENT_GET_ALL_REQUEST());
    }, [dispatch]);

    const toggleViewMode = (viewType) => {
        setViewMode(viewType);
    };

   const updateBreadcrumb = useCallback((item) => {
        setBreadcrumb((prevBreadcrumb) => {
            const isDuplicate = prevBreadcrumb.some(b => b.path === item.path);
            
            if (!isDuplicate) {
                return [...prevBreadcrumb, { label: item.name, path: item.path }];
            }
            return prevBreadcrumb;
        });
       setLastViewPath(item);
    }, []);

    
    const handleDownloadClick = (item) => {
        setDeleteRecord(null)
        dispatch(appActions.MEDIAMANAGEMENT_DOWNLOAD_REQUEST(item));
    };

    const handleDeleteClick = useCallback((item) => {
        setDeleteRecord(item); 
    }, []);

    const handleDeleteConfirm = useCallback(() => {
    if (deleteRecord) {
        dispatch(appActions.MEDIAMANAGEMENT_DELETE_REQUEST({...deleteRecord}));
        setDeleteRecord(null); 
    }
    }, [dispatch, deleteRecord])

    const handleRefresh = useCallback(() => {
        dispatch(appActions.MEDIAMANAGEMENT_GET_ALL_REQUEST());
        setBreadcrumb([{ label: 'Home', path: '' }]);
    }, [dispatch]);

    // const handleUpload = useCallback((files) => {

    //    const formData = new FormData();

    //     // Append files
    //     for (let i = 0; i < files.length; i++) {
    //         formData.append('files', files[i]);
    //     }

    //     // Append path (you can get this from a state or input field)
    //     formData.append('path', breadcrumb[breadcrumb.length - 1]?.path || ''); // <-- Replace this as needed

    //     dispatch(appActions.MEDIAMANAGEMENT_FILEUPLOAD_REQUEST(formData));

    // }, [dispatch, breadcrumb]);

    const fileUploadRef = useRef(null);

    const handleUpload = ({ files }) => {
        const formData = new FormData();

        // ✅ Append each file under the key "files"
        files.forEach((file) => {
            formData.append("files", file);
        });

        // ✅ Append path from breadcrumb or wherever you store it
        const currentPath = breadcrumb[breadcrumb.length - 1]?.path || '';
        formData.append("path", currentPath);

        const URL = window && window.config && window.config.END_POINT;

        // ✅ Use your HTTP client to post it
        axios.post(`${URL}/integration/media/upload`, formData, {
            headers: {
            'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            dispatch(appActions.MEDIAMANAGEMENT_GET_ALL_REQUEST(currentPath));
            showToast('success', 'Success', `files have been successfully uploaded.`)
            fileUploadRef.current.clear();
        }).catch((error) => {
            console.error("Upload failed", error);
            showToast('error', 'Error', `Upload failed ${error}`);
            fileUploadRef.current.clear();
        });
    };



    useEffect(() => {
        if (isDelete) {
            const timeoutId = setTimeout(() => {
                updateBreadcrumb(lastViewPath);
                dispatch(appActions.MEDIAMANAGEMENT_GET_ALL_REQUEST(lastViewPath?.path));
            }, 1000); // 1 seconds timeout

            return () => clearTimeout(timeoutId); // Cleanup on unmount
        }
    }, [isDelete, lastViewPath, dispatch, updateBreadcrumb]);

    const getFileIcon = (item) => {

        if(item.directory){
            return FolderIcon; 
        }

        const fileExtension = item.name.split('.').pop().toLowerCase();

        switch (fileExtension) {
            case 'json':
                return JsonIcon;
            case 'xml':
                return XmlIcon;
            case 'tlog':
                return TlogIcon;
            case 'fgpmlog':
                return TlogIcon;
            case 'fgmlog':
                return TlogIcon;
            case 'zip':
                return ZipIcon;
            default:
                return FileIcon;
        }
    };

    const renderHeader = () => (
        <div className="d-flex flex-row gap-10 align-items-center">
            <Toast ref={toast} />
            <h1 className="page-header flex">File Management</h1>
            <Button icon="pi pi-sync" rounded text aria-label="Refresh" data-pr-tooltip="Refresh" className='mr-auto tp' onClick={handleRefresh} />
           
            { ( uploadAccess && breadcrumb?.length > 1 ) &&
                <FileUpload
                    ref={fileUploadRef}
                    mode="basic"
                    name="files"
                    maxFileSize={1000000}
                    customUpload
                    uploadHandler={handleUpload}
                    auto
                    chooseLabel="File Upload"
                />
            }
            <ButtonGroup>
                <Button text onClick={() => toggleViewMode('list')} className="p-0" > 
                    <img src={ListIcon} alt="List Icon" className="grid-icon tp" data-pr-tooltip="List View"/>
                </Button>
                <Button text onClick={() => toggleViewMode('grid')} className="p-0"> 
                    <img src={GridIcon} alt="Grid Icon" className="grid-icon tp" data-pr-tooltip="Grid View"/>
                </Button>
            </ButtonGroup>
        </div>
    );

    const renderBreadcrumb = () => (
        <BreadcrumbView breadcrumbs={breadcrumb} onSelect={handleBreadcrumbSelect} />
    );

    const handleBreadcrumbSelect = (breadcrumbItem, index) => {
        dispatch(appActions.MEDIAMANAGEMENT_GET_ALL_REQUEST(breadcrumbItem.path));
        const updatedBreadcrumb = breadcrumb.slice(0, index + 1);
        setBreadcrumb(updatedBreadcrumb);
    };

   const renderActionButtons = (item) => (
        <div className="icon-container">
            {item.directory ? (
                <>
                   {/* View and Download icons for directories */}
                   { readAccess &&
                       <i
                           data-pr-tooltip="View"
                           className="pi pi-eye view-icon floatRight tp"
                           onClick={(e) => { e.stopPropagation(); viewDirectory(item); }}
                       />
                   }
                   {writeAccess &&
                       <DownloadFile filePath={item.path} directory={item.directory || false} toast={toast} onClick={() => handleDownloadClick(item)} />
                   }
                   { ( deleteAccess && item.path.replace(/\\/g, "/").includes("/archived") ) && (
                        <i 
                            data-pr-tooltip="Delete" 
                            className="pi pi-trash view-icon floatRight tp" 
                            onClick={(e) => { e.stopPropagation(); handleDeleteClick(item); }} 
                        />
                    )}
                </>
            ) : (
                /* Only Download and Delete icons for non-directories */
                <>
                    <DownloadFile filePath={item.path} directory={item.directory || false} toast={toast} onClick={() => handleDownloadClick(item)} />
                    {item.path.replace(/\\/g, "/").includes("/archived") && (
                        <i 
                            data-pr-tooltip="Delete" 
                            className="pi pi-trash view-icon floatRight tp" 
                            onClick={(e) => { e.stopPropagation(); handleDeleteClick(item); }} 
                        />
                    )}
                </>
            )}
        </div>
    );

    const renderDirectoryContents = (directory) => (
        Array.isArray(directory) && directory.length > 0 ? (
            directory.map((item, index) => (
                <div
                    key={index}
                    className={`directory-item gap-10 ${viewMode === 'grid' ? 'grid-item' : 'list-item align-items-center'} shadow-white flex-fill ${!item.directory ? 'file-item' : ''}`}
                >
                    <img src={getFileIcon(item)} alt="FileIcon" className="file-icon" />
                    <h5 className="fileName">{item.name}</h5>
                    {viewMode === 'list' && <h6 className="wd-175px">{item.modifiedDate}</h6>}
                    {renderActionButtons(item)}
                </div>
            ))
        ) : (
            <p>No children found in directory.</p>
        )
    );
    
    
    const viewDirectory = (item) => {
        updateBreadcrumb(item);
        setDeleteRecord(null);
        dispatch(appActions.MEDIAMANAGEMENT_GET_ALL_REQUEST(item.path));
    };

    return (
        <>
            <Toast ref={toast} />
             {loading && <Loader />} {/* Show loader if loading is true */}
            <div className='pv-15 ph-15'>
                {renderHeader()}
                {renderBreadcrumb()}
            </div>
            <div className="mx-3 br-6 mb-70">
                {Array.isArray(mediaList) && mediaList.length > 0 ? (
                    <>
                    {viewMode === 'list' && <>
                        <div className={`d-flex flex-wrap gap-10 flex-row show-action`}>
                            <h3 className="row-title mr-auto">Name</h3>
                            <h3 className="row-title">Date Modify</h3>
                            <h3 className="row-title">Action</h3>
                        </div>
                    </>}
                    <div className={`d-flex flex-wrap gap-10 ${viewMode === 'grid' ? ' flex-row text-center' : ' flex-column show-action'}`}>
                        {renderDirectoryContents(mediaList)}
                    </div>
                    </>
                    
                ) : (
                    <p>No media available or failed to load media.</p>
                )}
            </div>
            {deleteRecord && (
                <ConfirmationDialog
                    message={`Are you sure you want to delete the ${deleteRecord.directory ? 'folder' : 'file'} : ${deleteRecord?.name}?`}
                    onAccept={handleDeleteConfirm}
                    onReject={() => setDeleteRecord(null)}
                />
            )}
        </>
    );
};

export default MediaDirectoryTree;
